import React, { Component } from "react";
import ContentIcon, { HEADING_WEBVIEW } from "ContentIcon";
import { connect } from "react-redux";
import _ from "lodash";
import { IMAGE_PATH, itemCount } from "Constants";
import Pagination from "react-js-pagination";
import LocaleStrings from "Languages";
import FormItem from "./form-item-list";
import ProposalUrl from "./proposal-url.js";
import EditForm from "./edit-form.js";
import { fetchProposalForm } from "ProposalAction";
import { fetchEventDetails } from "DashboardUserAction";

class ProposalForm extends Component {
  constructor(props) {
    super(props);

    this.state = { pageNumber: 1, search: "" };
  }

  componentDidMount() {
    this.props.fetchProposalForm(this.props.session);
    this.props.fetchEventDetails(this.props.session);
  }

  renderProposalList = () => {
    let pageDataLength = this.props.proposalFormList.data.length;
    let { pageNumber } = this.state;

    return _.map(this.props.proposalFormList.data, (form) => {
      if (form.proposal_by_formid && form.proposal_by_formid.length > 0) {
        return (
          <FormItem
            key={form.id}
            form={form}
            pageDataLength={pageDataLength}
            currentPage={pageNumber}
            pagination={this.paginationCallback}
          />
        );
      }
    });
  };

  render() {
    var { proposalFormList, eventDetails } = this.props;
    //console.log('proposalFormList',proposalFormList);
    let style = {
      paddingTop: 25,
      paddingLeft: 15,
    };

    return (
      <div>
        <div className="panel-body">
          {this.props.showProposalUrlModal.showModal ? (
            <ProposalUrl eventDetails={eventDetails} />
          ) : (
            ""
          )}
          {this.props.editProposalModal.showModal ? <EditForm /> : ""}
          {proposalFormList &&
          proposalFormList.data &&
          proposalFormList.data.length > 0 ? (
            <div className="sponsor-table" style={{ marginTop: 60 }}>
              <table className="table ticketTable">
                <thead>
                  <tr>
                    <th>{LocaleStrings.proposal_form_number_heading}</th>
                    <th>{LocaleStrings.proposal_form_name_heading}</th>
                    <th>{LocaleStrings.proposal_form_proposal_name_heading}</th>
                    <th>{LocaleStrings.proposal_form_version_heading}</th>
                    <th>
                      {LocaleStrings.proposal_form_application_duration_heading}
                    </th>
                    <th style={{ paddingLeft: 90 }}>
                      {LocaleStrings.dashboard_action}
                    </th>
                  </tr>
                </thead>
                <tbody>{this.renderProposalList()}</tbody>
              </table>
              {this.props.proposalFormList.data &&
              this.props.proposalFormList.count > 20 ? (
                <Pagination
                  activePage={this.state.pageNumber}
                  itemsCountPerPage={20}
                  totalItemsCount={this.props.proposalFormList.count}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                  style={{ float: "right" }}
                />
              ) : (
                ""
              )}
            </div>
          ) : this.state.search != "" ? (
            <div className="no-content-container">
              <div className="no-content-message">
                {LocaleStrings.proposal_text_no_form}
              </div>
            </div>
          ) : (
            <div className="no-content-container">
              <div className="no-content-message">
                {LocaleStrings.proposal_text_no_form}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log('state.SettingData :- ', state.SettingData);
  return {
    session: state.session,
    proposalFormList: state.proposalFormList,
    showProposalUrlModal: state.showProposalUrlModal,
    eventDetails: state.userEventDetails,
    editProposalModal: state.editProposalModal,
  };
}

export default connect(mapStateToProps, {
  fetchProposalForm,
  fetchEventDetails,
})(ProposalForm);
